module.exports = __webpack_public_path__ + "img/党建平台.39ffa706.png";